<!--  -->
<template>
  <div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">推广名称：</div>
      <el-input
        v-model="promotionName"
        style="width:300px"
        placeholder="请输入内容"
      />
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">推广方式：</div>
      <el-radio-group v-model="promotionType">
        <el-radio :label="1">媒体投放</el-radio>
        <el-radio :label="2">达人挂载</el-radio>
      </el-radio-group>
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">内容类型：</div>
      <el-radio-group v-model="contentType">
        <el-radio :label="1">小说</el-radio>
        <el-radio
          :label="2"
          disabled
        >短剧</el-radio>
        <el-radio
          :label="3"
          disabled
        >短篇</el-radio>
      </el-radio-group>
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">起始章节/单章价格类型：</div>
      <el-radio-group v-model="chapterType">
        <el-radio :label="1">全局维度</el-radio>
        <el-radio
          :label="2"
          disabled
        >内容维度</el-radio>
        <el-radio
          :label="3"
          disabled
        >链接维度</el-radio>
      </el-radio-group>
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">引导关注弹窗：</div>
      <el-radio-group v-model="followWindowState">
        <el-radio :label="1">展示</el-radio>
        <el-radio :label="0">不展示</el-radio>
      </el-radio-group>
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext"></div>
      <div>*引导关注弹窗方式以公众号配置菜单下设置为准</div>
    </div>
    <div
      class="optionbox demo-ruleForm"
      v-if="followWindowState === 1"
    >
      <div class="optiontext">关注章节：</div>
      <el-radio-group v-model="followChapterType">
        <el-radio :label="2">按内容维度</el-radio>
        <el-radio
          :label="1"
          disabled
        >按全局维度</el-radio>
        <el-radio :label="3">链接维度</el-radio>
      </el-radio-group>
    </div>
    <div
      class="optionbox demo-ruleForm"
      v-if="followWindowState === 1 && followChapterType === 3"
    >
      <div class="optiontext">关注章节：</div>
      <el-input
        v-model="followChapterNo"
        style="width:300px"
        placeholder="请输入关注章节"
        type="number"
        min="1"
        @input="checkNegative"
      />
    </div>
    <el-button
      type="primary"
      @click="sumbit"
    >确定</el-button>
  </div>
</template>

<script>
import { bookPlatformcreate } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    obj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      promotionName: '',
      promotionType: 1,
      contentType: 1,
      chapterType: 1,
      followWindowState: 0,
      followChapterType: 2,
      followChapterNo: '',
      allobj: {}
    }
  },
  watch: {
    obj: {
      handler(newValue, oldValue) {
        console.log('111', newValue)
        this.objquery = newValue
        // this.name = newValue.bookname + '-' + newValue.chaptername
      },
      deep: true
    }
  },
  created() {
    this.objquery = this.obj
  },
  mounted() {},
  methods: {
    async sumbit() {
      if (this.objquery.platformvalue === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.objquery.bookid === null) {
        this.$message.error('请选择书籍')
        return
      }
      if (this.objquery.chapterid === null) {
        this.$message.error('请选择章节')
        return
      }
      if (this.promotionName === '') {
        this.$message.error('请输入推广名称')
        return
      }
      if (this.followWindowState === 1 && this.followChapterType === 3 && this.followChapterNo === '') {
        this.$message.error('请输入关注章节')
        return
      }
      this.allobj = {}
      if (this.followWindowState === 0) {
        this.allobj.followWindowState = this.followWindowState
      }
      if (this.followWindowState === 1 && this.followChapterType === 2) {
        this.allobj.followWindowState = this.followWindowState
        this.allobj.followChapterType = this.followChapterType
      }
      if (this.followWindowState === 1 && this.followChapterType === 3) {
        this.allobj.followWindowState = this.followWindowState
        this.allobj.followChapterType = this.followChapterType
        this.allobj.followChapterNo = this.followChapterNo
      }
      const data = await bookPlatformcreate({
        platform_id: this.objquery.platformvalue,
        template_data: {
          contentId: this.objquery.bookid,
          chapterId: this.objquery.chapterid,
          promotionName: this.promotionName,
          promotionType: this.promotionType,
          contentType: this.contentType,
          chapterType: this.chapterType,
          chapter_name: this.objquery.chaptername,
          ...this.allobj
        }
      })
      this.$emit('close')
      this.$message({
        message: '添加成功',
        type: 'success'
      })
      console.log('data', data)
    },
    checkNegative() {
      this.followChapterNo = Math.max(1, parseInt(this.followChapterNo))
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.optionbox {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.optiontext {
  width: 100px;
  text-align: right;
}

.demo-ruleForm /deep/ .el-input__inner {
  line-height: 1px !important;
}

/**
 * 解决el-input设置类型为number时，去掉输入框后面上下箭头
 **/
.demo-ruleForm /deep/ input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
